// src/router.js
import { createRouter, createWebHistory } from 'vue-router';
import Home from '@/components/Home.vue';
import Auth from '@/components/Auth.vue';
import Contractor from '@/views/Contractor.vue'; // Newly added Contractor component
import store from '@/store';
import Questionnaire from '@/components/Questionnaire.vue';
import Registration from "./components/Registration.vue";

const routes = [
  
  {
    path: '/contractor',
    name: 'Contractor',
    component: Contractor,
    meta: { requiresAuth: true }
  },
  {
    path: '/reset-password',
    name: 'ResetPassword',
    component: () => import('@/views/ResetPassword.vue')
  },
  {
    path: '/request-password-reset',
    name: 'RequestReset',
    component: () => import('@/views/RequestReset.vue')
  },
  {
    path: '/questionnaire',
    name: 'questionnaire',
    component: Questionnaire,  // your questionnaire component
    meta: { requiresAuth: false }         // if authentication is required
  }
  
  
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  next();
  
});

export default router;

